export enum ClarityStatus {
  NotConnected = 'NotConnected',
  Approved = 'Approved',
  Declined = 'Declined',
  Expired = 'Expired',
  Pending = 'Pending',
  Cancelled = 'Cancelled',
  NotFound = 'NotFound',
}
